"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setInitialFocus = exports.clickPayeeLink = exports.getNextField = exports.countNonZeroRows = exports.splitRowsRemainder = exports.sumSplitsRows = exports.getBaseAmount = void 0;
const scheduled_transactions_1 = require("companion-app-components/flux/scheduled-transactions");
const splitsHelpers_1 = require("data/transactions/splitsHelpers");
const getBaseAmount = (txn) => {
    if (!txn.type) {
        return txn.amount;
    }
    let baseAmount = txn.amount;
    switch (txn.type) {
        case scheduled_transactions_1.scheduledTransactionsTypes.STTypeEnum.INCOME: {
            if (baseAmount < 0) {
                baseAmount *= -1;
            }
            break;
        }
        case scheduled_transactions_1.scheduledTransactionsTypes.STTypeEnum.BILL: {
            if (baseAmount > 0) {
                baseAmount *= -1;
            }
            break;
        }
        default:
            break;
    }
    return baseAmount;
};
exports.getBaseAmount = getBaseAmount;
const sumSplitsRows = (splitRow) => (0, splitsHelpers_1.sumSplitRows)(splitRow);
exports.sumSplitsRows = sumSplitsRows;
const splitRowsRemainder = (txForm) => (0, splitsHelpers_1.splitTxnRemainder)(txForm);
exports.splitRowsRemainder = splitRowsRemainder;
const countNonZeroRows = (txObj) => (txObj.split.items.filter((splitItem) => Number(splitItem.amount) !== 0).length);
exports.countNonZeroRows = countNonZeroRows;
const getNextField = ({ splitsSideBySide, splitShowNotes, showDetails, showSplitsState }, currField, direction = 'forward') => {
    const amountBackField = splitShowNotes ? 'notes' : 'tags';
    const skip1 = 'tags';
    const skip2 = 'category';
    // Moving forward
    let focusField = null;
    if (direction === 'forward') {
        switch (currField) {
            case 'last-button':
                if (splitsSideBySide) {
                    focusField = showDetails ? 'details-first-tab' : 'splits-panel-onoff';
                }
                else {
                    focusField = 'splits-panel-onoff';
                }
                break;
            case 'details-last-tab':
                focusField = 'splits-panel-onoff';
                break;
            case 'splits-panel-onoff':
                if (!showSplitsState) {
                    focusField = 'first-button';
                }
                break;
            case 'splits-last-tab':
                if (splitsSideBySide) {
                    focusField = 'first-button';
                }
                break;
            default:
                if (currField && currField.includes(skip1)) {
                    const row = currField.split('-')[1];
                    focusField = `row-${row}-field-${skip2}`;
                }
                break;
        }
    }
    else {
        // Moving Backwards
        switch (currField) {
            case 'first-button':
                if (splitsSideBySide || !showDetails) {
                    focusField = showSplitsState ? 'splits-last-tab' : 'splits-panel-onoff';
                }
                else {
                    focusField = 'details-last-tab';
                }
                break;
            case 'splits-panel-onoff':
                if (showDetails) {
                    focusField = splitsSideBySide ? 'details-last-tab' : 'last-button';
                }
                else {
                    focusField = 'last-button';
                }
                break;
            case 'details-first-tab':
                focusField = splitsSideBySide ? 'last-button' : null;
                break;
            default:
                if (currField && currField.includes('amount')) {
                    const row = currField.split('-')[1];
                    focusField = `row-${row}-field-${amountBackField}`;
                }
                break;
        }
    }
    return focusField;
};
exports.getNextField = getNextField;
const clickPayeeLink = (name) => {
    window.open(`https://www.google.com/search?q=${encodeURIComponent(name)}`);
};
exports.clickPayeeLink = clickPayeeLink;
const setInitialFocus = (retry, log, showSplitsState) => {
    log.log('setting focus');
    const node = showSplitsState ?
        document.querySelectorAll('[name="row-0-field-category"]') :
        document.querySelectorAll('[name="details-first-tab"]');
    if (node && node.length > 0) {
        // needed delay, sometimes focus was not sticking
        setTimeout(() => node[0].focus(), 150);
        node[0].focus();
    }
    else if (retry) {
        setTimeout(() => (0, exports.setInitialFocus)(false, log, showSplitsState), 250, false);
    }
};
exports.setInitialFocus = setInitialFocus;
